<template>
  <div>
    <order-list
      :direction="direction"
      @dialogHide="dialogHide"
      @checkOrder="checkOrder"
      ref="orderList"
      v-if="listStatus"
    />
    <div
      v-show="isShow"
      class="input-area page-footer"
      :class="[{ isSafari: isSafari, newheight: more }]"
    >
      <div
        v-show="isEntering"
        :class="messageImgs.length > 0 ? 'isimg' : ''"
        class="entering"
      >
        客服正在输入...
      </div>
      <chat-emotion v-model="emotionVisible" @select="selectEmotion" />

      <textarea
        ref="message-textarea"
        type="text"
        placeholder="请输入您的问题"
        @click.right="showTextareaRightMenu"
        @keyup.enter="send"
        @paste="getClipboardFiles"
        maxlength="1024"
        v-model.trim="message"
        @click="handleFocus"
        @input="changeText"
        @focus="textFocus"
        @blur="textBlur"
        :class="isshowsend ? 'width' : ''"
      />

      <div class="toolbar">
        <i class="icon-emoji" @click="showEmotion"></i>
        <!-- <i class="icon-image" @click="clickimg">
            <upload-image-message
              class="copyImg"
              :isShowCopy="true"
              @clickbanner="clickbanner"
              ref="mychild"
            />
          </i> -->
        <!-- <i class="icon-comment" @click="commentHandler"></i>
          <i class="el-icon-document" @click="findorder"></i> -->
        <i class="icon-comment" @click="commentHandler"></i>
      </div>

      <div
        v-if="isshowsend"
        class="primary-btn"
        @click="sendMobile"
        :class="{ disabled: sendButtonDisabled || isMsgUpload }"
      >
        发送
      </div>

      <img
        src="@/assets/imgs/add_more.svg"
        class="el-icon-circle-plus"
        v-if="!isshowsend"
        @click="isShows"
      />
    </div>
    <!-- <i class="el-icon-circle-plus" ></i> -->
    <CoolLightBox
      :slideshow="isshow"
      :items="uploadImages"
      :index="index"
      @close="closeImg"
    />
    <div v-if="more" class="more">
      <span @click="clickimg">
        <img src="@/assets/imgs/photo-image.svg" alt="" />
        <upload-image-message
          class="copyImg"
          :isShowCopy="true"
          @clickbanner="clickbanner"
          ref="mychild"
        />
      </span>
      <span class="imageText">图片</span>
      <span
        v-if="urlData.enterScene != 5 && customerInfo.type != 2"
        class="dingdan"
        @click.stop="findorder"
      >
        <img src="@/assets/imgs/dingdan.svg" alt="" />
      </span>
      <span
        v-if="urlData.enterScene != 5 && customerInfo.type != 2"
        class="orderText"
        >订单</span
      >
    </div>
  </div>
</template>

<script>
import inputArea from "src/mixins/inputArea";
import uploadImageMessage from "./upload-image-message";
import { Notification } from "element-ui";
import orderList from "src/app/customer/components/orderList";
import utils from "../../utils";
import { judgeDeviceType } from "../../utils/env";

export default {
  name: "page-footer",
  mixins: [inputArea],
  components: { orderList, uploadImageMessage },
  computed: {
    ...mapState({
      messageImgs: state => state.chat.messageImgs,
      blackFlag: state => state.blackFlag,
      serverId: state => state.serverId,
      userId: state => state.userId,
      channelId: state => state.channelId,
      isMsgUpload: state => state.isMsgUpload,
      isSend: state => state.isSend,
      isEntering: state => state.isEntering,
      more: state => state.more,
      isshowsend: state => state.isshowsend,
      listStatus: state => state.listStatus,
      sendEnterFlag: state => state.sendEnterFlag,
      customerInfo: state => state.customerInfo,
      urlData: state => state.urlData
    }),
    isSafari() {
      return (
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent)
      );
    },
    sendButtonDisabled() {
      //当为空消息且图片为空时 true
      return !this.message && !this.messageImgs.length;
    }
  },
  data() {
    return {
      direction: "",
      time: null,
      isTap: true,
      blob: {},
      isshow: false,
      images: [],
      index: null,
      uploadImages: [],
      sendEnterTimer: null,
      clientHeight: document.documentElement.clientHeight,
      currentHeight: document.documentElement.clientHeight,
      isShow: true
    };
  },
  watch: {
    nowHeight: function() {
      if (this.clientHeight > this.currentHeight) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    message(newVal) {
      if (this.isSend && !this.message) {
        this.sendEnter(
          this.$customerConstant.CUSTOMER_CONSTANT.CANCEL_ENTERING
        );
        return;
      }
      this.$store.commit("setState", {
        isSend: false
      });
      if (newVal) {
        this.sendEnter(this.$customerConstant.CUSTOMER_CONSTANT.ENTERING);
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.currentHeight = document.documentElement.clientHeight;
      })();
    };
    // window.addEventListener(
    //   "touchmove",
    //   function(event) {
    //     if (event.scale !== 1) {
    //       event.preventDefault();
    //     }
    //   },
    //   { passive: false }
    // );
    // var timer = {
    //   id:null,
    //   run:function (callback,time) {
    //     this.id = window.setInterval(callback,time);
    //   },
    //   clean:function () {
    //     var that = this;
    //     this.id = window.clearInterval(that.id);
    //   }
    // };
    // var keyboardHeight = 0,screenHeight = window.innerHeight;
    // let input = this.$refs.messageTextarea;
    // input.addEventListener('focus',function (evt) {
    //   if(!keyboardHeight){
    //     timer.run(function () {
    //       if (screenHeight !== window.innerHeight) {
    //         keyboardHeight = screenHeight-window.innerHeight;
    //         timer.clean()
    //       }
    //     }, 50)
    //   }
    // });
    // input.focus();
  },
  methods: {
    handleFocus(isfocus) {
      if (judgeDeviceType().isIOS) {
        const chatEl = document.querySelector("#chat-message-wraper");
        const chatItems = document.querySelectorAll(".chat-message-item");
        console.log(chatEl, "=====");
        if (chatItems.length < 6) {
          if (isfocus) {
            chatEl.style.paddingTop = "250px";
          } else {
            chatEl.style.paddingTop = "15px";
          }
        }
      }
    },

    checkOrder(item) {
      this.$store.commit("setState", { listStatus: false });
      utils.sendOrder(item);
    },

    changeText() {
      console.log(this.message.length, "长度");
      if (this.message.length > 0) {
        this.$store.commit("setState", {
          isshowsend: true
        });
      } else {
        this.$store.commit("setState", {
          isshowsend: false
        });
        // this.isshowsend=false
      }
    },
    isShows() {
      if (this.more) {
        this.$store.commit("setState", {
          more: false
        });
      } else {
        this.$store.commit("setState", {
          more: true
        });
      }
    },
    dialogHide() {
      this.$store.commit("setState", { listStatus: false });
    },
    findorder() {
      this.direction = "btt";
      this.$store.commit("setState", { listStatus: true, activeName: "1" });
      // this.$refs.orderList.getData();
      // this.$store.commit("setState", {
      //   more: false
      // });
    },
    clickimg() {
      this.$store.commit("setState", {
        isclickimg: true,
        more: true
      });
    },
    textFocus() {
      window.addEventListener("keyboardup", function(e) {
        console.log("键盘谈起", e, e.height);
      });
      this.handleFocus(true);

      const isMi9 =
        navigator.userAgent.indexOf("XiaoMi/MiuiBrowser") > -1 &&
        navigator.userAgent.indexOf("Mi9") > -1;

      const isXiaoMiOrQQ =
        navigator.userAgent.indexOf("MQQBrowser") > -1 ||
        navigator.userAgent.indexOf("XiaoMi/MiuiBrowser") > -1;

      console.log(isMi9, "isMi9");
      console.log(isXiaoMiOrQQ, "isXiaoMiOrQQ");

      // if (isMi9) {
      //   clearTimeout(this.time);
      //   this.time = setTimeout(() => {
      //     document.querySelector(".input-area").style.paddingBottom =
      //       320 + "px";
      //   }, 300);
      // } else if (isXiaoMiOrQQ) {
      //   clearTimeout(this.time);
      //   this.time = setTimeout(() => {
      //     document.querySelector(".input-area").style.paddingBottom =
      //       290 + "px";
      //   }, 300);
    },
    textBlur() {
      this.handleFocus(false);

      clearTimeout(this.time);
      this.time = setTimeout(() => {
        document.querySelector(".input-area").style.paddingBottom = 0 + "px";
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    getClipboardFiles(e) {
      let that = this;
      const html = e.clipboardData.getData("text/html");
      if (html.indexOf("excel") >= 0) {
        this.blob = "";
        return false;
      }
      for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
        var item = e.clipboardData.items[i];
        if (item.kind === "string") {
          item.getAsString(function(str) {
            if (
              str.indexOf("amazonaws.com") > -1 &&
              (str.indexOf("png") > -1 ||
                str.indexOf("jpg") > -1 ||
                str.indexOf("jpeg") > -1)
            ) {
              console.log("含有图片");
              that.message = "图片";
            }
            // str 是获取到的字符串
          });
        } else if (item.kind === "file") {
          var pasteFile = item.getAsFile();
          console.log("文件", pasteFile);
          // pasteFile就是获取到的文件
        }
      }
    },
    closeImg() {
      this.index = null;
      document.querySelector(".header").style.zIndex = "5";
      // document.querySelector(".page-footer").style.zIndex = "1";
      this.index = null;
      this.uploadImages = [];
    },
    // 轮播
    clickbanner(e) {
      this.uploadImages = [];
      for (let i = 0; i < this.messageImgs.length; i++) {
        if (e.target.currentSrc == this.messageImgs[i].url) {
          this.index = i;
        }
        var obj = {};
        obj["src"] = this.messageImgs[i].url;
        this.uploadImages.push(obj);
      }
      this.isshow = true;
      document.querySelector(".header").style.zIndex = "-1";
      // document.querySelector(".page-footer").style.zIndex = "-1";
    },
    commentHandler() {
      if (this.isTap) {
        this.isTap = false;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          this.isTap = true;
        }, 3000);
        if (this.blackFlag != 0) {
          Notification.warning({
            title: "提示：",
            message: "您暂时不能发起评价",
            position: "top-left"
          });
          return;
        }
        this.$store.commit("setState", {
          visibleEvaluate: true
        });
      }
    },
    sendEnter(num) {
      if (this.sendEnterFlag) {
        return;
      }
      this.$store.commit("setState", {
        sendEnterFlag: true
      });
      this.$service
        .serviceEntering({
          channelId: this.channelId,
          serverId: this.serverId,
          userId: this.userId,
          type: num
        })
        .then(res => {
          if ((res && res.code != 200) || !res) {
            clearTimeout(this.sendEnterTimer);
            this.$store.commit("setState", {
              sendEnterFlag: false
            });
          }
        })
        .catch(() => {
          clearTimeout(this.sendEnterTimer);
          this.$store.commit("setState", {
            sendEnterFlag: false
          });
        });
      let that = this;
      this.sendEnterTimer = setTimeout(() => {
        that.$store.commit("setState", {
          sendEnterFlag: false
        });
      }, 8000);
    }
  },
  beforeDestroy() {
    clearTimeout(this.sendEnterTimer);
    this.sendEnterFlag = false;
    clearTimeout(this.time);
  }
};
</script>
<style>
.mobile .more .upload-wrap .upload-area .el-upload--picture-card {
  top: -50px;
  width: 50px;
  height: 50px;
}
.mobile .more .upload-wrap .upload-area .el-upload-list {
  top: -120px;
  left: 0px;
}
.mobile .more .upload-wrap {
  width: 100vw;
}
</style>
<style lang="less" scoped>
.more {
  height: 200px;
  clear: both;
  padding-top: 10px;

  position: fixed;
  bottom: 60px;
  z-index: 999;

  .el-icon-picture {
    position: relative;
    top: 15px;
    left: 20px;
  }
  .dingdan {
    position: absolute;
    top: 8px;
    left: 65px;
    img {
      height: 58px;
    }
  }
  .imageText {
    position: absolute;
    top: 65px;
    font-size: 12px;
    left: 10px;
  }
  .orderText {
    position: absolute;
    top: 65px;
    font-size: 12px;
    left: 80px;
  }
}
.newheight {
  height: 300px !important;
}
.entering {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  font-size: 12px;
  color: #787878;
  height: 25px;
  line-height: 25px;
  padding: 0 5px 0 10px;
  width: 110px;
  z-index: 9;
  background: #ffffff;
  border-radius: 3px;
  top: -25px;
}
.isimg {
  top: -105px;
}
/deep/.el-icon-error {
  font-size: 20px;
  position: absolute;
  z-index: 66;
  right: 0;
  top: 0;
  color: red;
  background: #fff;
  border-radius: 100%;
}
</style>
<style lang="less" scoped>
.el-icon-circle-plus {
  position: relative;
  top: 10px;
  // left:30px;
  width: 25px;
}
.mobile {
  .chat-textarea {
    width: 98%;
    position: fixed;
  }

  .input-area {
    position: fixed;
    display: inline-block;
    justify-content: space-between;
    align-items: center;
    height: 49px;
    padding: 0 6px;
    background-color: #fff;
    z-index: 1;
    bottom: 0;
    width: 100%;
    .isSafari {
      position: fixed !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 13.0666666666667vw;
      padding: 0 1.6vw;
      background-color: #fff;
      z-index: 1;
      bottom: -77px !important;
      width: 100%;
    }

    textarea {
      min-width: 196px;
      width: auto;
      width: calc(100% - 90px);
      height: 38px;
      background: #f4f4f4;
      border-radius: 5px;
      padding: 9px 0 9px 10px;
      outline: none;
      border: none;
      float: left;
      margin-top: 5px;
      &::placeholder {
        color: #c8c8c8;
      }
    }
    .width {
      width: calc(100% - 120px);
    }
    .toolbar {
      display: inline-block;
      float: left;
      width: 50px;
      height: 38px;
      line-height: 38px !important;
      margin: 5px 4px 0;
      i {
        display: inline-block;
        background-size: 100% 100%;
        // padding:5px;
        margin: 7px 2px;
        width: 21px;
        height: 21px;
      }

      .icon-emoji {
        background-image: url("../../../../assets/imgs/icon-emoji.svg");
        &:active {
          background-image: url("../../../../assets/imgs/icon-emoji-active.png");
        }
      }
      .icon-comment {
        background-image: url("../../../../assets/imgs/icon-comment.svg");
        &:active {
          background-image: url("../../../../assets/imgs/icon-comment-active.png");
        }
      }
    }

    .primary-btn {
      width: 58px;
      height: 38px;
      margin-top: 4px;
      border-radius: 5px;
      text-align: center;
      line-height: 38px;
      display: inline-block;
      background: var(--button-bg) !important;
    }
    .disabled {
      opacity: 0.3;
    }
  }
}
</style>
